import { render, staticRenderFns } from "./PubgPlayerTable.vue?vue&type=template&id=26dcb3c4"
import script from "./PubgPlayerTable.vue?vue&type=script&lang=js"
export * from "./PubgPlayerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports